<template>
  <div id="schedule">
    <div class="schedule-container">
      <div class="schedule-tabs-container">
        <div class="schedule-tabs-container__inner">
          <template v-for="channel in liveChannels">
            <button v-if="channel.active"
                    :key="channel.id"
                    type="button"
                    :class="{ active: activeLiveChannel === channel.id }"
                    class="schedule-tabs-container__inner__button"
                    @click="updateTab(channel.id)"
            >
              {{ channel.name }}
            </button>
          </template>
        </div>
      </div>
      <Transition name="fade" mode="out-in">
        <keep-alive>
          <ScheduleCurrentShow
            v-if="activeLiveChannel === 1"
            :key="liveChannels[0].name"
            :live-channel="liveChannels[0]"
          />
          <ScheduleCurrentShow
            v-else-if="activeLiveChannel === 2"
            :key="liveChannels[1].name"
            :live-channel="liveChannels[1]"
          />
          <ScheduleCurrentShow
            v-else-if="activeLiveChannel === 3"
            :key="liveChannels[2].name"
            :live-channel="liveChannels[2]"
          />
        </keep-alive>
      </Transition>
      <Transition name="fade" mode="out-in">
        <keep-alive>
          <ScheduleTabPane
            v-if="activeLiveChannel === 1"
            :key="liveChannels[0].name"
            :live-channel="liveChannels[0]"
          />
          <ScheduleTabPane
            v-else-if="activeLiveChannel === 2"
            :key="liveChannels[1].name"
            :live-channel="liveChannels[1]"
          />
          <ScheduleTabPane
            v-else-if="activeLiveChannel === 3"
            :key="liveChannels[2].name"
            :live-channel="liveChannels[2]"
          />
        </keep-alive>
      </Transition>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ScheduleTabPane from '@/components/schedule/ScheduleTabPane.vue';
import ScheduleCurrentShow from '@/components/schedule/ScheduleCurrentShow.vue';

export default {
  name: 'Schedule',
  components: {
    ScheduleTabPane,
    ScheduleCurrentShow
  },
  data: () => ({
    schedule: [],
    activeLiveChannel: 1,
    isSecondChannelScheduleActive: false,
    liveChannels: [
      {id: 1, name: 'Live 1', baseURL: 'https://movementathens.airtime.pro', active: true},
      {id: 2, name: 'Live 2', baseURL: 'https://stegiradio3.airtime.pro', active: false},
      {id: 3, name: 'Live 3', baseURL: 'https://movementathens2.airtime.pro', active: false}
    ]
  }),
  mounted() {
    this.getSecondChannelScheduleStatus();
    this.getThirdChannelScheduleStatus();
  },
  methods: {
    updateTab(id) {
      console.log('id::', id);
      this.activeLiveChannel = id;
    },
    getSecondChannelScheduleStatus() {
      axios
          .get(this.$router.options.api + '/front/is-second-channel-schedule-active')
          .then(response => {
            if (response.data.active) {
              this.liveChannels.map((e) => {
                if (e.id === 2) {
                  e.active = response.data.active;
                }
              })
            }
          })
          .catch(error => console.error(error));
    },
    getThirdChannelScheduleStatus() {
      axios
          .get(this.$router.options.api + '/front/is-third-channel-schedule-active')
          .then(response => {
            if (response.data.active) {
              this.liveChannels.map((e) => {
                if (e.id === 3) {
                  e.active = response.data.active;
                }
              })
            }
          })
          .catch(error => console.error(error));
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/pages/_schedule.scss';
</style>
